module.exports = __webpack_public_path__ + "static/media/rhodes_0010_wakefieldcouncil.ec732eea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rhodes_0010_wakefieldcouncil.jpg
// module id = 171
// module chunks = 0